import { SELECTABLE_COLUMN_WIDTH } from '@aibees/shared/features/advance-table/constant';
import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const tableRowSelectCellInnerBox: SxStyle = {
  height: (p) => p.spacing(3),
  width: SELECTABLE_COLUMN_WIDTH,
  pl: 0,
};

export const tableNoDataRow: SxStyle = {
  background: 'none!important',
};

export const tableSortIconWrapper: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const tableNoDataCell: SxStyle = {
  justifyContent: 'center',
  // background: (p) => p.palette.background.default,
  borderRadius: (p) => p.spacing(1),
  m: 'auto',
  background: 'none!important',
  padding: 0,
};

export const tableHeaderRow: SxStyle = {
  zIndex: 1000,
  th: {
    color: (p) => p.palette.grey[800],
  },
};

export const tableSortLabel: SxStyleFunc<{
  active: boolean | undefined;
  sortableField: boolean;
}> = ({ active, sortableField }) => ({
  display: 'flex',
  justifyContent: sortableField ? 'flex-start' : 'space-between',
  gap: sortableField ? 0.5 : 0,

  '&:hover': {
    svg: {
      path: {
        color: (p) => p.palette.primary[500],
      },
    },
  },

  svg: {
    borderRadius: (p) => p.spacing(0.5),
    background: (p) => p.palette.grey[200],
    padding: (p) => p.spacing(0.25),

    path: {
      color: active
        ? (p) => p.palette.primary[500]
        : (p) => p.palette.grey[500],
    },
  },
});

export const tableHeadCellTooltip: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const tableHeadCellTooltipIcon: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
};

export const paginationWrapper: SxStyle = {
  position: 'relative',
  backgroundColor: (p) => p.palette.grey[200],
  borderRadius: 1,
  // marginY: 0.5,
  paddingX: 2,
};

export const pageSelector: SxStyle = {
  height: 26,
  minWidth: 60,
  backgroundColor: (p) => p.palette.common.white,
  borderRadius: 0.5,
  border: (p) => `1px solid ${p.palette.grey[300]}`,
  '.MuiSelect-select': {
    paddingLeft: 1,
    paddingY: 0,
  },
  fieldset: {
    border: 0,
  },
};

export const jumpToPageInput: SxStyle = {
  marginLeft: 1,

  '.MuiInputBase-root': {
    height: (p) => p.spacing(3.25),
    backgroundColor: (p) => p.palette.common.white,
    borderRadius: 0.5,
    border: (p) => `1px solid ${p.palette.grey[300]}`,
  },
  fieldset: {
    border: 0,
  },
  input: {
    paddingY: 0,
    paddingX: 0.5,
  },
};

export const jumpToPageButton: SxStyle = {};

export const tablePagination: SxStyle = {
  borderTopColor: 'transparent',
  width: 'max-content',

  '.MuiTablePagination-actions': {
    display: 'none',
  },
  '.MuiTablePagination-displayedRows': {
    marginY: 0,
  },
  '.MuiToolbar-root': {
    height: (p) => p.spacing(7),
  },
};

export const pagination: SxStyle = {
  marginLeft: 2,
  button: {
    color: (p) => p.palette.grey[700],
    height: (p) => p.spacing(2.75),
    minWidth: (p) => p.spacing(2.75),
    borderRadius: 0.5,
    '&.Mui-selected': {
      color: (p) => `${p.palette.common.black} !important`,
      backgroundColor: (p) => `${p.palette.common.white} !important`,
    },
  },
};

export const emptyIconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  outlineWidth: (p) => p.spacing(0.5),
  outlineStyle: 'solid',
  outlineColor: (p) => p.palette.grey[200],
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
};

export const noDataContent: SxStyle = {
  height: 'auto',
  padding: (p) => p.spacing(10, 0),
  // width: '100%',
};

export const emptyIconBox: SxStyle = {
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(2),
  padding: (p) => p.spacing(0.75),
  display: 'inline-block',
};

export const emptyIcon: SxStyle = {
  color: (p) => p.palette.grey[400],
};

export const noDataTitleBox: SxStyle = {
  position: 'relative',
  display: 'inline-flex',
  minWidth: (p) => p.spacing(10),
  maxWidth: '100%',
  height: 'auto',
};

export const noDataTitleBox1: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(5),
  width: '100%',
  height: '100%',
  top: (p) => p.spacing(2),
};

export const noDataTitleBox2: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(2),
  width: '100%',
  height: '100%',
  top: (p) => p.spacing(1),
};

export const noDataTitleWrapper: SxStyle = {
  position: 'relative',
  background: (p) => p.palette.common.white,
  // width: '100%',
  border: '1px solid',
  borderColor: (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.25, 2),
  boxSizing: 'border-box',
};

export const titleSx: SxStyle = {
  wordBreak: 'break-word',
  textAlign: 'center',
};
